import React from 'react';
import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/react';
import s from './Subtitle.scss';

export function Subtitle() {
  const { t } = useTranslation();

  return (
    <Text
      size="medium"
      className={s.landingSubtitle}
      secondary
      textAlign="center"
    >
      {t('devibe.onboarding.subtitle')}
    </Text>
  );
}
